export const ELEMENT_SELECTOR = '[data-subscribe-form]';

$(document).on('ready markupReady', function () {

	const $elements = $(ELEMENT_SELECTOR);
	if ($elements && $elements.length) {
		System.import(
			/* webpackChunkName: "components/subscription-form" */
			'./component')
			.then(({subscribeForm}) => {
				$elements.each((index, element) => new subscribeForm(element));
			});
	}

});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/subscription-form/index.js